<!-- app页面——我的收藏 -->
<template>
  <div class="myCollectionH5">
    <van-nav-bar title="我的收藏" left-arrow @click-left="toBack" />
    <div class="content">
      <!-- 文档列表 -->
      <van-pull-refresh class="folderList" v-model="refreshing" @refresh="onRefresh" v-loading="loading">
        <div class="folderItem" v-for="item in myCollectionList" :key="item.folderId" @click="nextDetails(item)">
          <oneFileFolder :key="item.folderId" :item="item" @moreOpen="moreOpen(item)"></oneFileFolder>
        </div>
        <div class="empty" v-if="!myCollectionList.length">暂无数据</div>
      </van-pull-refresh>
    </div>

    <!-- 更多弹框 -->
    <myCollectionMore ref="myCollectionMore" @toRefresh="toRefresh" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Notify } from "vant";
import { viewAppFileMethods } from "@/CommonDP/pages/appView/utils";
import { throttle } from "@/CommonDP/utils/throttle.js"; // 函数节流
import docService from "@/CommonDP/service/doc-service";
import oneFileFolder from "../../components/oneFileFolder.vue";
import myCollectionMore from "./myCollectionMore.vue";

export default {
  components: { oneFileFolder, myCollectionMore },
  data() {
    return {
      page: {
        pageSize: 999,
        pageNum: 1
      }, // 分页
      myCollectionList: [], // 我的收藏列表
      refreshing: false,
      loading: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.getMyCollectionList();
  },
  methods: {
    // 返回上一页
    toBack() {
      this.$router.go(-1);
    },

    // 获得我的收藏列表
    async getMyCollectionList() {
      this.loading = true;
      try {
        let { pageSize, pageNum } = this.page;
        let enterpriseId = this.enterpriseId;
        const res = await docService.queryPersonFavorite(pageSize, pageNum, enterpriseId);
        this.myCollectionList = res.data || [];
      } finally {
        this.loading = false;
      }
    },

    // 刷新列表
    toRefresh() {
      this.getMyCollectionList();
    },
    // 下拉刷新
    async onRefresh() {
      try {
        await this.getMyCollectionList();
      } finally {
        this.refreshing = false;
      }
    },
    // 点击文件夹，进入下一级
    nextDetails: throttle(async function (item) {
      if (item.isFolder === 1) {
        let { prjId, folderId } = item || {};
        // 我的文档
        if (prjId === "MyDoc") {
          const { data } = await docService.navbar(1, folderId);
          if (data) {
            let navList = data.map((ele) => {
              let { folderId, folderName } = ele;
              return { folderId, folderName };
            });
            this.$router.push({ path: "/personDocH5/myDocH5", query: { navList } });
          } else {
            return Notify({ type: "warning", message: "该文件路径已失效" });
          }
        }
      } else {
        // 预览文件
        if (item.isDelete === 1) {
          return Notify({ type: "warning", message: "该文件已删除，无法查看" });
        }
        const value = {
          fileId: item.folderId,
          versionId: item.fileVersion,
          fileType: item.fileType,
          noNeedIssue: "true"
        };
        viewAppFileMethods(item, value);
      }
    }),

    // 点击... 打开更多
    moreOpen(item) {
      if (item.isFolder === 1) this.$refs.myCollectionMore.setFolderPrivi(item);
      else this.$refs.myCollectionMore.setFilePrivi(item);
    }
  }
};
</script>

<style lang="scss" scoped>
.myCollectionH5 {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-color: #f5f6fa;

  .content {
    width: 100%;
    height: calc(100% - 56px);
    margin-top: 10px;
  }
}

.folderList {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .empty {
    width: 100%;
    height: calc(100% - 66px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--info-color)9;
    font-size: 16px;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
